export default __webpack_public_path__ + "static/2157-96325121910903962623c2e2a82bb528.gif";